import { render, staticRenderFns } from "./editDrawer.vue?vue&type=template&id=067dcd3c&scoped=true"
import script from "./editDrawer.vue?vue&type=script&lang=js"
export * from "./editDrawer.vue?vue&type=script&lang=js"
import style0 from "./editDrawer.vue?vue&type=style&index=0&id=067dcd3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067dcd3c",
  null
  
)

export default component.exports